module.exports = __webpack_public_path__ + "media/images/icons/crop-23c961bce042a6a2c3eef68aaacd1c66.svg";